import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import SeanceReportList, { DispatchProps, OwnProps, StateProps } from './SeanceReportList';
import { StoreState } from 'src/store/reducers';
import { QueryParams } from 'src/types/grid';
import {
    getSeanceReports,
    getSeanceReportsCsv,
    getSeanceReportsTotal,
    clearTotal,
} from 'src/store/actions/seanceReport-actions';

import { getProvidersSmall } from '../../../../../store/actions/provider-actions';
import { selectNameProviders } from '../../../../../store/selectors/providers-selectors';
import { getServiceTypes } from '../../../../../store/actions/service-type-actions';
import { getStudentsSmall } from '../../../../../store/actions/student-actions';
import { selectNameStudents } from '../../../../../store/selectors/students-selectors';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        data: state.seanceReports.data,
        inProgress: state.seanceReports.inProgress,
        providers: selectNameProviders(state),
        students: selectNameStudents(state),
        totals: state.seanceReports.totals,
        serviceTypes: state.serviceTypes.data,
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getData: (params: QueryParams) => dispatch(getSeanceReports(params)),
        getDataCsv: (params: QueryParams) => dispatch(getSeanceReportsCsv(params)),
        getDataTotal: (params: QueryParams) => dispatch(getSeanceReportsTotal(params)),
        getProviders: (params: QueryParams) => dispatch(getProvidersSmall(params)),
        getStudents: (params: QueryParams) => dispatch(getStudentsSmall(params)),
        clearTotal: () => dispatch(clearTotal()),
        getServiceTypes: (params: QueryParams) => dispatch(getServiceTypes(params)),
    };
}

const SeanceReportListScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(SeanceReportList);

export default SeanceReportListScreen;
